import WorldMapView from '../views/worldMap.view.html?raw';

export default class WorldMap {
    constructor(domainsService, translateService) {
        this.domainsService = domainsService;
        this.translate = translateService;

        this.restrict = 'E';
        this.template = WorldMapView;
        this.scope = {
            regions: '=worldMap',
            active: '=?active',
            extensions: '=extensions',
            limit: '@?limit'
        };
    }

    link(scope, elm, attrs) {
        const translate = this.translate;

        scope.limit = 28;
        scope.showAll = false;
        scope.domainsService = this.domainsService;

        scope.domainsByRegions = scope.domainsService.getExtensionsListByRegions();
        scope.activeRegion = 'europe';
        scope.listOfDomainsSelectedRegion = scope.domainsByRegions[scope.activeRegion];

        scope.countryFlagExceptions = {
            'eu.com': 'eu',
            'ею': 'eu',
            'ευ': 'eu'
        };

        scope.regionsDescriptions = {
            'africa': translate.t('common.regions.africa'),
            'asia': translate.t('common.regions.asia'),
            'europe': translate.t('common.regions.europe'),
            'middle-east': translate.t('common.regions.middle_east'),
            'north-america': translate.t('common.regions.north_america'),
            'south-america': translate.t('common.regions.south_america'),
            'australia': translate.t('common.regions.australia'),
        };

        scope.getFlagCode = function(domain) {
            if (domain.country !== null && domain.country.iso_code !== null) {
                return domain.country.iso_code.toLowerCase();
            }

            if (scope.countryFlagExceptions.hasOwnProperty(domain.extension_idn) === true) {
                return scope.countryFlagExceptions[domain.extension_idn].toLowerCase();
            }

            return domain.extension_idn.toLowerCase();
        };

        scope.select = function (name) {
            scope.showAll = false;
            scope.activeRegion = name;
            scope.listOfDomainsSelectedRegion = scope.domainsByRegions[scope.activeRegion];
        };

        scope.toggleShow = function () {
            scope.showAll = !scope.showAll;
        };

        scope.buildDomainUrl = function (extension) {
            const routeUrl = translate.t('routes.domain_database');
            if (routeUrl === 'routes.domain_database') {
                return '/';
            }
            return translate.buildUrl('/' + translate.t('routes.domain_database') + '/' + encodeURIComponent(extension));
        };
    }

    static directiveFactory(domainsService, translateService) {
        return new WorldMap(domainsService, translateService);
    }
}
